// extracted by mini-css-extract-plugin
export default {"root":"IconPlus_root__J1pRK","horizontalLine":"IconPlus_horizontalLine__1Gc-H","verticalLine":"IconPlus_verticalLine__-L0P1","lineVerticalOpen":"IconPlus_lineVerticalOpen__obAS6"};